import { mapState } from 'vuex';

import toggler from '@/components/Toggler/Toggler.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faLink,
  faMoneyBillWave,
  faHome,
  faUserShield,
  faCog,
  faUsers,
  faCartArrowDown,
  faUserCircle,
  faCube,
  faPaintBrush,
  faEnvelopeOpen,
  faChevronUp,
  faChevronDown,
  faFillDrip
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faLink,
  faMoneyBillWave,
  faHome,
  faUserShield,
  faCog,
  faUsers,
  faCartArrowDown,
  faUserCircle,
  faCube,
  faPaintBrush,
  faEnvelopeOpen,
  faChevronUp,
  faChevronDown,
  faFillDrip
);

export default {
  name: 'sidebar',

  mounted() {
    this.collapseByViewport();
    window.addEventListener('resize', this.onResize);
  },

  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },

  computed: {
    ...mapState({
      firmId: state => state.user.profile.id,
      isAdmin: state => state.user.profile.isAdmin
    }),

    navReady() {
      return this.$store.state.user.constructors
        ? this.$store.getters.navReady
        : null;
    },

    isFullView() {
      return this.$store.state.navigation.fullView;
    }
  },

  methods: {
    onClickToggle(groupIndex, itemIndex) {
      this.navReady[groupIndex].items[itemIndex].collapsed = !this.navReady[
        groupIndex
      ].items[itemIndex].collapsed;
    },

    onClickLink(groupIndex, itemIndex) {
      if (typeof groupIndex !== 'undefined') {
        this.navReady[groupIndex].items[itemIndex].collapsed = false;
      }
      if (window.innerWidth < 1024) this.$store.commit('collapse');
    },

    onResize() {
      // this.collapseByViewport();
    },

    collapseByViewport() {
      if (window.innerWidth < 1024) {
        this.$store.commit('collapse');
      } else {
        this.$store.commit('expand');
      }
    }
  },

  components: {
    FontAwesomeIcon,
    toggler
  }
};
